<template>
    <div class="row mb-3">
        <div class="col-12">
            <div class="card">
                <div class="card-header d-flex p-3">
                    <h5>{{ TR.customers }}</h5>
                </div>

                <div class="card-body p-0">
                    <div class="row">
                        <div class="col">

                            <DADataTable
                                ref="product_table_ref"
                                v-if="tableData"
                                :tableData="tableData"
                                :tableOptions="tableOptions"
                            />

                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>


<script scoped>
    import { onMounted, ref, watchEffect } from "vue";

    import { useStore } from "@/store";

    import { G, ajax } from "@/_common";

    import DADataTable from "@/components/table/DADataTable";

    export default {
        name: 'ProductsCategory',
        components: {
            DADataTable,
        },
        setup() {
            const store = useStore();

            const tableData = ref([]);
            const tableOptions = ref();
            const product_category = ref([]);
            const product_table_ref = ref();
            const TR = ref({});

            onMounted(async () => {
                await ajax({
                    url: store.getProductsCategoryLink(),
                    success: (e) => {
                        const res = e.data || null;
                        if (res) {
                            product_category.value = [];
                            product_category.value.push({ value: 0, label: `<b>${TR.value.main}</b>` });
                            product_category.value = product_category.value.concat(res.map((e) => {
                                return { value: e.id, label: e.translate[0].name };
                            }));
                            tableData.value = res;
                            tableData.value.forEach(x => x.create_date = new Date(x.create_date));
                        }
                    }
                });
            });


            watchEffect(() => {
                TR.value = store.getTranslation();

                tableOptions.value = {
                    // row_total: false,
                    // row_per_page: 5,

                    header_buttons: [
                        {
                            private: G.privateIfNotPermission("add"),
                            label: TR.value.add_title,
                            icon: "fas fa-plus me-1",
                            class: "btn-primary",
                            eventCallback: () => {
                                G.showModal({
                                    title: TR.value.add_title,
                                    // subTitle: `<span class="text-danger1">${TR.value.name}</span>`,
                                    modal_width: 30,
                                    page: "components/table/DynamicTable2",
                                    data: {},
                                    table_columns: [
                                        {
                                            name: "preview_image",
                                            title: TR.value.preview,
                                            // value: (e) => e.image,
                                            value: "image",
                                            field_type: "label",
                                        },
                                        {
                                            name: "image",
                                            title: TR.value.image,
                                            // value: (e) => e.image,
                                            field_type: "image",
                                            fileSelectMode: 'basic',
                                            // fileSelectMode: 'advanced',
                                            fileMaxSize: 3000000,
                                            fileLimit: 1,
                                            fileMultiple: false,
                                        },
                                        {
                                            name: "name",
                                            title: TR.value.name,
                                            // value: (e) => e.translate[0].name,
                                            field_type: "text",
                                        },
                                        {
                                            name: "parent",
                                            title: TR.value.parent,
                                            field_type: 'dropdown',
                                            dropdown_items: product_category.value,
                                            dropdown_item_selected: 0
                                        },
                                        {
                                            name: "rank",
                                            title: TR.value.rank,
                                            value: () => 1,
                                            field_type: 'integer',
                                            max: 10000,
                                        },
                                    ],
                                    toolbar: {
                                        leftSide: {
                                            buttons: [
                                                {
                                                    label: TR.value.close,
                                                    icon: "fas fa-times",
                                                    class: "btn-secondary",
                                                    eventCallback: (e) => {
                                                        G.closeModal(e);
                                                    },
                                                },
                                                {
                                                    private: G.privateIfNotPermission("add"),
                                                    label: TR.value.save,
                                                    icon: "fas fa-save",
                                                    class: "btn-primary",
                                                    eventCallback: async (res) => {
                                                        let e = res.newdata;

                                                        if( e && e.name ){
                                                            let formData = new FormData();

                                                            if( e.image != null && typeof e.image === 'object' ){
                                                                formData.append("upload_image", e.image);
                                                            }

                                                            let category_data = {
                                                                "parent": e.parent,
                                                                "rank": e.rank,
                                                                "translate": [
                                                                    {
                                                                        "lang_id": 1,
                                                                        "name": e.name,
                                                                    }
                                                                ]
                                                            };
                                                            if( e.image != null && typeof e.image !== 'object' )
                                                                category_data.image = e.image;

                                                            formData.append("data", JSON.stringify(category_data));

                                                            await ajax({
                                                                url: store.getProductsCategoryLink(),
                                                                method: 'post',
                                                                data: formData,
                                                                success: (x) => {
                                                                    const res = x.data || null;
                                                                    if ( x.status == 200 && res) {
                                                                        res.create_date = new Date(res.create_date);
                                                                        tableData.value.push(res);
                                                                        G.alert.success(TR.value.msg_add_success);
                                                                    }
                                                                    else
                                                                        G.alert.error(res.detail);
                                                                },
                                                            });
                                                            G.closeModal(res);
                                                        }
                                                        else
                                                            G.alert.error(TR.value.msg_input_name);
                                                    },
                                                },
                                            ],
                                        },
                                    },
                                });
                            },
                        },
                    ],
                    row_buttons: [
                        {
                            private: G.privateIfNotPermission("remove"),
                            label: "",
                            title: TR.value.remove,
                            icon: "fas fa-trash",
                            class: "text-danger",
                            eventCallback: (data) => {
                                G.alert.confirm({ title: TR.value.warning, msg: TR.value.msg_are_you_sure, yesTitle: TR.value.yes, yes: async () => {
                                    await ajax({
                                        url: store.getCustomerCategoryUpdateLink(data.id),
                                        method: 'delete',
                                        success: (e) => {
                                            let res = e.data || null;
                                            if ( e.status == 200 && res){
                                                tableData.value.filter((x, i) => { if (x.id === data.id) tableData.value.splice(i, 1); } );
                                                G.alert.success(res.detail);
                                            }
                                            else
                                                G.alert.error(res.detail);
                                        },
                                    });
                                }, yesIcon: 'fas fa-check', noIcon: 'fas fa-ban', noTitle: TR.value.no, no: () => {} })
                            },
                        },
                        {
                            private: G.privateIfNotPermission("update"),
                            label: "",
                            title: TR.value.edit,
                            icon: "fas fa-pencil-alt",
                            class: "btn-primary",
                            eventCallback: (data) => {
                                G.showModal({
                                    title: TR.value.edit_title,
                                    subTitle: `${data.translate[0].name}`,
                                    modal_width: 30,
                                    page: "components/table/DynamicTable2",
                                    data: data,
                                    table_columns: [
                                        {
                                            name: "preview_image",
                                            title: TR.value.preview,
                                            // value: (e) => e.image,
                                            value: "image",
                                            field_type: "label",
                                        },
                                        {
                                            name: "image",
                                            title: TR.value.image,
                                            value: (e) => e.image,
                                            field_type: "image",
                                            fileSelectMode: 'basic',
                                            fileMaxSize: 3000000,
                                            fileLimit: 1,
                                            fileMultiple: false,
                                        },
                                        {
                                            name: "name",
                                            value: (e) => e.translate[0].name,
                                            title: TR.value.name,
                                            field_type: 'text',
                                        },
                                        {
                                            name: "parent",
                                            value: "parent",
                                            title: TR.value.parent,
                                            // field_type: 'text',
                                            field_type: 'dropdown',
                                            dropdown_items: product_category.value.filter(e => e.value !== data.id),
                                            dropdown_item_selected: data.parent
                                        },
                                        {
                                            name: "rank",
                                            value: "rank",
                                            title: TR.value.rank,
                                            field_type: 'integer',
                                            max: 10000,
                                        },
                                        {
                                            name: "create_date",
                                            value: (e) => G.formatLocale(e.create_date),
                                            title: TR.value.create_date,
                                            field_type: "label",
                                        },
                                    ],
                                    toolbar: {
                                        leftSide: {
                                            buttons: [
                                                {
                                                    label: TR.value.close,
                                                    icon: "fas fa-times",
                                                    class: "btn-secondary",
                                                    eventCallback: (el) => {
                                                        G.closeModal(el);
                                                    },
                                                },
                                                {
                                                    private: G.privateIfNotPermission("update"),
                                                    label: TR.value.save,
                                                    icon: "fas fa-save",
                                                    class: "btn-primary",
                                                    eventCallback: async (res) => {
                                                        let e = res.newdata;

                                                        let formData = new FormData();
                                                        if( e.image != data.image && typeof e.image === 'object' ){
                                                            formData.append("upload_image", e.image);
                                                        }
                                                        let category_data = {
                                                            "parent": e.parent,
                                                            "rank": e.rank,
                                                            "translate": [
                                                                {
                                                                    "lang_id": 1,
                                                                    "name": e.name,
                                                                }
                                                            ]
                                                        };
                                                        if( e.image != data.image && typeof e.image !== 'object' )
                                                            category_data.image = e.image;

                                                        formData.append("data", JSON.stringify(category_data));

                                                        await ajax({
                                                            url: store.getProductsCategoryUpdateLink(data.id),
                                                            method: 'patch',
                                                            data: formData,
                                                            success: (x) => {
                                                                const res = x.data || null;
                                                                if (res) {
                                                                    res.create_date = new Date(res.create_date);
                                                                    tableData.value.forEach(
                                                                        (s) => { if ( s.id === res.id ) { s = res; } }
                                                                    );
                                                                    for (let a in res) {
                                                                        data[a] = res[a];
                                                                    }
                                                                    G.alert.success(TR.value.msg_success);
                                                                }
                                                            },
                                                        });
                                                        G.closeModal(res);
                                                    },
                                                },
                                            ],
                                        },
                                    },
                                });
                            },
                        },
                    ],
                    data_table_columns: [
                        {
                            name: "id",
                            title: TR.value.id,
                            value: "id",
                            class: 'text-center',
                            filter: false,
                        },
                        {
                            name: "image",
                            value: (e) => `<img src="${
                                                        e.image
                                                            ? e.image
                                                            : "/assets/img/noimg.png"
                                                    }"
                                                    alt="${e.image}"
                                                    class="border img-circle-cover"
                                                />`,
                            title: TR.value.image,
                            exportable: false,
                            sortable: false,
                            class: 'text-center',
                            filter: false,
                        },
                        {
                            name: "translate.0.name",
                            value: (e) => e.translate[0].name,
                            title: TR.value.name,
                        },
                        {
                            name: "parent",
                            value: "parent",
                            title: TR.value.parent,
                            class: 'text-center',
                            filter: false
                        },
                        {
                            name: "rank",
                            value: "rank",
                            title: TR.value.rank,
                            class: 'text-center',
                            filter: false
                        },
                        {
                            name: "create_date",
                            value: "create_date",
                            title: TR.value.create_date,
                            class: 'text-center',
                            filters: {
                                operator: "or",
                                constraints: [{ value: null, matchMode: "dateBefore" }],
                            },
                            filter_format: 'dd.mm.yy',
                            data_type: "date",
                            filter_mode: "datetime",
                        },
                    ],
                };

            });

            return {
                TR,
                product_table_ref,
                tableData,
                tableOptions,
                // getCustomers,
            };
        },
    };
</script>

